module.exports = __webpack_public_path__ + "img/hand-back-point-right.685543b1.svg";